import { createSlice } from '@reduxjs/toolkit';
import { createInitialStatePart, setReducerState } from '../utils/reduxUtils';

const STATE_KEY = 'ghost';
const initialState = {
  ...createInitialStatePart('guidePages', []),
  ...createInitialStatePart('guidePost'),
  ...createInitialStatePart('sdkPages', []),
  ...createInitialStatePart('sdkPost'),
  guidePageId: '',
  guidePostId: '',
  sdkPageId: '',
  sdkPostId: ''
};

const ghost = createSlice({
  name: STATE_KEY,
  initialState,
  reducers: {
    loadGuidePages: (state) => {
      return setReducerState('loading', 'guidePages', { state });
    },
    loadGuidePagesSuccess: (state, { payload }) => {
      return setReducerState('loaded', 'guidePages', { state, data: payload });
    },
    loadGuidePagesFail: (state, action) => {
      return setReducerState('error', 'guidePages', { state, error: action.payload });
    },
    loadGuideContent: (state, action) => {
      const { guidePageId, guidePostId } = action.payload;
      return setReducerState('loading', 'guidePost', {
        state: {...state, guidePageId, guidePostId, guidePostLoaded: false},
        action
      });
    },
    loadGuideContentSuccess: (state, { payload }) => {
      return setReducerState('loaded', 'guidePost', { state, data: payload });
    },
    loadGuideContentFail: (state, action) => {
      return setReducerState('error', 'guidePost', { state, error: action.payload });
    },
    loadSdkPages: (state) => {
      return setReducerState('loading', 'sdkPages', { state });
    },
    loadSdkPagesSuccess: (state, { payload }) => {
      return setReducerState('loaded', 'sdkPages', { state, data: payload });
    },
    loadSdkPagesFail: (state, action) => {
      return setReducerState('error', 'sdkPages', { state, error: action.payload });
    },
    loadSdkContent: (state, action) => {
      const { sdkPageId, sdkPostId } = action.payload
      return setReducerState('loading', 'sdkPost', {
        state: {...state, sdkPageId, sdkPostId, sdkPostLoaded: false},
        action
      });
    },
    loadSdkContentSuccess: (state, { payload }) => {
      return setReducerState('loaded', 'sdkPost', { state, data: payload });
    },
    loadSdkContentFail: (state, action) => {
      return setReducerState('error', 'sdkPost', { state, error: action.payload });
    },
    loadGhostPages: (state) => {
      return state;
    },
  },
});

export const {
  loadGuidePages,
  loadGuidePagesSuccess,
  loadGuidePagesFail,
  loadGuideContent,
  loadGuideContentSuccess,
  loadGuideContentFail,
  loadSdkPages,
  loadSdkPagesSuccess,
  loadSdkPagesFail,
  loadSdkContent,
  loadSdkContentSuccess,
  loadSdkContentFail,
  loadGhostPages
} = ghost.actions;

export default ghost.reducer;
